<template>
  <el-dialog
    title="检查费用"
    :visible.sync="isShow"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="closeDetail"
    width="1200px"
  >
    <div v-if="formData.isSend == 0 && [0, 1, 2].indexOf(formData.outlayStatus) > -1" style="text-align: right; padding: 0 16px 16px 0; background: white;">
      <el-button v-if="rowData.outlayStatus != 1" :loading="btnLoading" type="primary" icon="el-icon-s-release" size="mini" @click="saveData">暂存</el-button>
      <el-button :loading="btnLoading" type="primary" icon="el-icon-success" size="mini" @click="submitData">提交</el-button>
    </div>
    <div v-if="rowData.outlayStatus == 0" style="padding: 16px;">
      <CheckOutlayDetail
        ref="checkOutlay"
        :recordId="recordId"
        @beforeSave="btnLoading = true"
        @saveComplete="btnLoading = false"
        @close="closeDetail"
        @success="formSaveSuccess"
        @load="formOnLoad">
      </CheckOutlayDetail>
    </div>
    <el-tabs v-if="rowData.outlayStatus > 0" v-model="dialogActiveName">
      <el-tab-pane label="费用信息" name="outlayInfo">
        <CheckOutlayDetail
          ref="checkOutlay"
          :recordId="recordId"
          @beforeSave="btnLoading = true"
          @saveComplete="btnLoading = false"
          @close="closeDetail"
          @success="formSaveSuccess"
          @load="formOnLoad">
        </CheckOutlayDetail>
      </el-tab-pane>
      <el-tab-pane label="审核记录" name="outlayHistory">
        <OutlayHistory v-if="dialogActiveName == 'outlayHistory'" :outlayId="recordId"></OutlayHistory>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import CheckOutlayDetail from './CheckOutlayDetail'
import OutlayHistory from '../view/OutlayHistory'

export default {
  components: {
    CheckOutlayDetail,
    OutlayHistory
  },
  props: {
    dialogVisible: false,
    rowData: {
      type: Object,
      default () {
        return {}
      }
    },
    recordId: {
      type: String
    }
  },
  data () {
    return {
      isShow: this.dialogVisible,
      btnLoading: false,
      dialogActiveName: 'outlayInfo',
      formData: {}
    }
  },
  methods: {
    formOnLoad (outlay) {
      this.formData = outlay;
    },
    saveData () {
      this.$refs.checkOutlay.saveData();
    },
    submitData () {
      this.$refs.checkOutlay.submitData();
    },
    closeDetail () {
      this.btnLoading = false;
      this.$emit("update:dialogVisible", false);
    },
    formSaveSuccess (outlay) {
      this.btnLoading = false;
      this.$emit('success', outlay)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/dialog.scss";
</style>



// WEBPACK FOOTER //
// src/pages/outlay/check/CheckOutlayDialog.vue